var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99969 7.83531C8.00485 7.83531 8.81969 7.02047 8.81969 6.01531C8.81969 5.01015 8.00485 4.19531 6.99969 4.19531C5.99453 4.19531 5.17969 5.01015 5.17969 6.01531C5.17969 7.02047 5.99453 7.83531 6.99969 7.83531Z",
    stroke: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11036 4.9538C3.25952 -0.0978633 10.7437 -0.0920297 11.887 4.95964C12.5579 7.92297 10.7145 10.4313 9.09869 11.983C7.92619 13.1146 6.07119 13.1146 4.89286 11.983C3.28286 10.4313 1.43952 7.91714 2.11036 4.9538Z",
    stroke: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.86f97b5ad40fff18be0a91320c88f044.svg";
export { ForwardRef as ReactComponent };